import 'bootstrap';
import './elements/st-media-settings';
import './elements/time-picker';
import './frontpage/index';
import ProfilePage from './profile/profileIndex';
import FormValidation from './util/form-validation';

FormValidation();
ProfilePage();